import React from 'react';
import SortTable from '../../SortTable';
import {convertDateTimeFormatToDate} from "../../../utils";
import Icon from '../../Icon';
import trash from '../../../svgs/Trash.svg'
import view from '../../../svgs/eye_open.svg'


const tabEyeball = (tabKey, el, handleShowHistoryTab) => (
    <div className='icon-normal history-financials-icon' onClick={() => handleShowHistoryTab(el, tabKey)}><Icon svg={view}/></div>
);

const hasPaymentData = (el) => (
    el && el.STATUS === 'Closed' && el.SOURCE === 'SUMMIT' && el.HAS_PAYMENT_SNAPSHOT === true
);

const hasLoanData = (el) => (
    !!el && (el.SOURCE === 'HSC' || !!el.HSC_FINANCING)
);

const columns  = (viewMode, handleDeleteHistory, handleShowHistoryTab) => [{
    name: 'Date Listed',
    code:'DATE',
    render: (el) => (el.STATUS === 'Closed' ? '-' : (el.DATE ? convertDateTimeFormatToDate(el.DATE) : '-')),
}, {
    name: 'Date Sold',
    code:'DATE',
    render: (el) => (el.STATUS === 'Closed' ? (el.DATE ? convertDateTimeFormatToDate(el.DATE) : '-') : '-'),
}, {
    name: 'Status',
    code:'STATUS',
    render: (el) => (el.STATUS ? el.STATUS : '-'),
}, {
    name: 'Source',
    code:'SOURCE',
    render: (el) => (el.SOURCE ? el.SOURCE : '-'),
}, {
    name: 'Property',
    render: (el) => tabEyeball('PROPERTY', el, handleShowHistoryTab),
}, {
    name: 'Investor',
    render: (el) => tabEyeball('INVESTORS', el, handleShowHistoryTab),
}, {
    name: 'Listing Agent',
    render: (el) => tabEyeball('LISTING AGENT', el, handleShowHistoryTab),
}, {
    name: 'Proposal',
    render: (el) => tabEyeball('PROPOSAL', el, handleShowHistoryTab),
}, {
    name: 'Rep Agreement',
    render: (el) => tabEyeball('REP AGREEMENT', el, handleShowHistoryTab),
}, {
    name: 'Financials',
    render: (el) => tabEyeball('FINANCIALS', el, handleShowHistoryTab),
}, {
    name: 'In Neg/Under Contract',
    render: (el) => tabEyeball('IN NEG/UNDER CONTRACT', el, handleShowHistoryTab),
}, {
    name: 'Buyside Agent',
    render: (el) => tabEyeball('BUYSIDE AGENT', el, handleShowHistoryTab),
}, {
    name: 'Sale Info',
    render: (el) => tabEyeball('SALE INFO', el, handleShowHistoryTab),
}, {
    name: 'Website',
    render: (el) => tabEyeball('WEBSITE', el, handleShowHistoryTab),
}, {
    name: 'Payment',
    render: (el) => (hasPaymentData(el) ? tabEyeball('PAYMENT', el, handleShowHistoryTab) : '-'),
}, {
    name: 'Loan Info',
    render: (el) => (hasLoanData(el) ? tabEyeball('LOAN INFO', el, handleShowHistoryTab) : '-'),
}, {
    name: 'Loan Quotes',
    render: (el) => (hasLoanData(el) ? tabEyeball('LOAN QUOTES', el, handleShowHistoryTab) : '-'),
}, {
    name: 'Date Changed',
    code: 'DATE_CHANGED',
    render: (el) => (el.DATE_CHANGED ? convertDateTimeFormatToDate(el.DATE_CHANGED) : '-'),
}, {
    name: 'Delete Row',
    render: (el) => (el.ARCIMEDES_ROW_ID ? <div className="icon-container" onClick={() => handleDeleteHistory(el.ARCIMEDES_ROW_ID)}><Icon svg={trash}/></div> : ''),
}];

const PropertyHistory = ({data, query, deleted, viewMode, handleDeleteHistory, handleShowHistoryTab}) => {
    return(
    <div className={`Property-history${deleted ? ' deleted' : ''}`}>
        <div className='invisible'/>
        {
            data && data.length ?
                <SortTable
                    query={query}
                    columns={columns(viewMode, handleDeleteHistory, handleShowHistoryTab)}
                    items={data}
                    classNameModifier='property-history'
                />
                :
                <div className='no-results'>No results.</div>
        }
    </div>)
}
export default PropertyHistory;
